module.exports = __webpack_public_path__ + "static/media/editIcon.7aad9155.svg";